import { marketPlaceHomeData } from "@/api/productAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const getMarketPlaceHomeData = createAsyncThunk(
    'marketplace/getMarketPlaceHomeData',
    async (reqObj) => {
        const reponse = await marketPlaceHomeData(reqObj);
        return reponse;
    }
);

const marketPlaceSlice = createSlice({
    name: "marketplace",
    initialState: { marketplaceData: [], loading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMarketPlaceHomeData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMarketPlaceHomeData.fulfilled, (state, action) => {
                state.loading = false;
                state.marketplaceData = action.payload
            })
            .addCase(getMarketPlaceHomeData.rejected, (state, action) => {
                state.loading = false;
                state.error = "Something Went Wrong!"
            });
    }
});

export const getMarketPlaceData = (state) => state.marketplace.marketplaceData;

export default marketPlaceSlice.reducer;